import classNames from 'classnames';
import type { Dispatch } from 'react';

import { Input, Text } from '@revelio/ui';

import type { TabContentAction } from '../PageConfigProvider/page-reducer';
import type { PositionedItem } from '../PageConfigProvider/types/item';
import { ArrowDirectionSelector } from './ArrowDirectionSelector';
import panelStyles from './ChartBuilderPanel.module.css';
import { ConfigSection } from './ConfigSection';
import styles from './diverging-bar-settings.module.css';
import labelStyles from './section-label.module.css';

const fieldClassName = classNames(panelStyles.field, panelStyles.compactField);

type DivergingBarSettingsProps = {
  item: PositionedItem;
  dispatch: Dispatch<TabContentAction>;
};

export const DivergingBarSettings = ({
  item,
  dispatch,
}: DivergingBarSettingsProps) => {
  const id = item?.id;

  return (
    <ConfigSection title="Arrows & labels">
      <div className={styles.fieldStack}>
        <div>
          <Text
            fontSize="sm"
            weight="semibold"
            className={classNames(
              labelStyles.fieldLabel,
              labelStyles.fieldLabelSpaced
            )}
          >
            Arrow orientation
          </Text>
          <ArrowDirectionSelector item={item} />
        </div>
        <div>
          <Text
            fontSize="sm"
            weight="semibold"
            className={labelStyles.fieldLabel}
          >
            Positive Label
          </Text>
          <Input
            size="sm"
            wrapperClassName={fieldClassName}
            placeholder=""
            value={item.plot?.divergingBar?.positiveLabel ?? ''}
            onChange={(e) => {
              dispatch({
                type: 'UPDATE_ITEM_DIVERGING_BAR',
                payload: {
                  id,
                  divergingBar: {
                    ...item.plot?.divergingBar,
                    positiveLabel: e.target.value,
                  },
                },
              });
            }}
          />
        </div>
        <div>
          <Text
            fontSize="sm"
            weight="semibold"
            className={labelStyles.fieldLabel}
          >
            Negative Label
          </Text>
          <Input
            size="sm"
            wrapperClassName={fieldClassName}
            placeholder=""
            value={item.plot?.divergingBar?.negativeLabel ?? ''}
            onChange={(e) => {
              dispatch({
                type: 'UPDATE_ITEM_DIVERGING_BAR',
                payload: {
                  id,
                  divergingBar: {
                    ...item.plot?.divergingBar,
                    negativeLabel: e.target.value,
                  },
                },
              });
            }}
          />
        </div>
      </div>
    </ConfigSection>
  );
};
